export default {
    JUNTADO: 'Juntado',
    NAO_JUNTADO: 'Não Juntado' ,
    CANCELADO: 'Cancelado'
}